/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * State of the deployment's current placement
 */
export enum DeploymentPlacementState {
	RUNNING = "running",
	STOPPED = "stopped",
	STARTING = "starting",
	STOPPING = "stopping",
}
